<template>
  <mini-card :value="nbLeadsReceived" :subtitle="'Leads Received'"
              :previousValue="$store.getters.totalLeadsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-inbox-in text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small">
        <!-- <span><i class="far fa-clock mr-2"/>Last received: &nbsp;<i>{{lastReceivedDate}}</i></span> -->
        <div class="col ml-0 pl-0">
          <a class="ml-3 mr-auto" href="#" @click="addLead()"><i class="fas fa-plus mr-1"/>lead</a>
        </div>
        <div class="col-4 col-lg-1">

        </div>
        <div class="col ml-auto pr-2">
          <span class=""> {{ submittedNb }} </span>
        </div>
      </div>
    </template>
  </mini-card>
</template>

<script>
import utils from '../../utils'
import MiniCard from './MiniCard.vue'
import { Lead } from 'src/classes/datamodel.js'
export default {
  name: 'Leads-Received-MiniCard',
  data () {
    return {}
  },
  components: {
    MiniCard
  },
  methods: {
    addLead () {
      this.$store.dispatch('openModal', {name: 'Lead',
                                         mode: 'Create',
                                         object: new Lead({status: Lead._status.RECEIVED.value,
                                                           incentifyerAccountId: this.$store.getters.companySelected || ''
                                                           })})
    },
  },
  computed: {
    lastReceivedDate () {
      // we find the most recently received lead
      const leads = this.$store.getters.leads
      let date = new Date(0)
      if (leads && leads.length > 0) {
        leads.forEach(lead => {
          if (!lead.archived
              && lead.dateReceived && lead.dateReceived.getTime() > date.getTime()) {
                date = lead.dateReceived
          }
        })
        if (date.getTime() > 0) {
          return utils.dateToString(date)
        }
      }
      return '-'
    },
    submittedNb () {
      const leads = this.$store.getters.leads.filter(l => l.status == Lead._status.SUBMITTED.value)
      return leads.length > 0  ? `submitted:  ${leads.length}` : ''
    },
    nbLeadsReceived () {
      return this.$store.getters.leads.filter(l => l.status != Lead._status.SUBMITTED.value).length || 0
    }
  }
}
</script>

<style>

</style>